import * as React from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Hidden,
  SvgIcon as MUISvg,
} from "@material-ui/core";
import {BoxProps} from "@material-ui/core/Box";
import {MUIPreloader} from "../../MUI";
import {useTheme} from "@material-ui/core/styles";
import {themeVariables} from "../_Theme";
import * as styles from "./styles.scss";
import cx from "classnames";
import {_viewport, tl} from "../../../../utils";
import {ICourse} from "../../Courses/GroupSettings/types";
import {IFile} from "../../Filestorage/types";

import {SvgIcon} from "../../../../components";
import {MUISticky} from "../Sticky";
import {Close} from "@material-ui/icons";
import CloseCompact from "../../../../components/Icons/closeCompact";

export interface IViewerItem {
  category: "image" | "video" | "course";
  id: number;
  name?: string;
  srcUrl?: string;
  date?: any;
  downloadUrl?: string;
  course?: ICourse;
}

interface IProps extends BoxProps {
  onClose: any;
  itemsList: any[];
  currentId: number;
  currentItem?: IViewerItem | IFile;
  showItem: (currentId: number) => IViewerItem | IFile;
  currentVideo?: any;
  actionButton?: any;
  courseCover?: any;
}

export const MUIViewer = (props: IProps) => {
  const theme = useTheme();
  const [isLoading, setLoading] = React.useState(true);
  const [currentId, setCurrentId] = React.useState<number>(props.currentId);
  const [currentItem, setCurrentItem] = React.useState<IViewerItem | IFile>(
    props.currentItem
  );

  const showPrev = () => {
    setLoading(true);
    setCurrentId(currentId - 1);
    setCurrentItem(props.showItem(currentId - 1));
  };
  const showNext = () => {
    setLoading(true);
    setCurrentId(currentId + 1);
    setCurrentItem(props.showItem(currentId + 1));
  };

  const body = (document as any).querySelector("body");
  const fullscreenAllowed =
    body.requestFullscreen ||
    body.webkitrequestFullscreen ||
    body.mozRequestFullscreen;
  const [isFullscreen, setIsFullscreen] = React.useState(false);

  let refContainer: any;

  const sizeViewer = (el?: any) => {
    const deltaW =
      _viewport().width < 768 ? 0 : _viewport().width < 1000 ? 100 : 200;
    let w =
        currentItem.category === "course" && _viewport().width > 767
          ? 658
          : (document as any).querySelector(".page").clientWidth - deltaW,
      h = w * 0.5625;
    const deltaH =
      _viewport().width < 1200 ? 50 : _viewport().width < 1800 ? 176 : 226;
    if (h > _viewport().height - deltaH) {
      h = _viewport().height - deltaH;
      w = (h * 16) / 9;
    }
    if (el) {
      el.style.cssText = `width: ${w}px; height: ${h}px;`;
    } else {
      return {minWidth: w, height: h};
    }
  };
  const sizeViewerHolder = () => {
    sizeViewer(refContainer);
  };

  const fullscreenToggle = () => {
    const el = !document.fullscreenElement ? refContainer : (document as any);
    if (!!document.fullscreenElement) {
      if (el.exitFullscreen) {
        el.exitFullscreen();
      } else if (el.mozCancelFullScreen) {
        el.mozCancelFullScreen();
      } else if (el.webkitExitFullscreen) {
        el.webkitExitFullscreen();
      } else if (el.msExitFullscreen) {
        el.msExitFullscreen();
      }
    } else {
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
      } else if (el.mozRequestFullscreen) {
        el.mozRequestFullScreen();
      } else if (el.msRequestFullscreen) {
        el.msRequestFullScreen();
      }
    }
  };

  React.useEffect(() => {
    if (currentItem.category !== "course") {
      (window as any).addEventListener("resize", sizeViewerHolder);

      const fuid = Math.floor(Math.random() * 1000000);
      return () => {
        (window as any).removeEventListener("resize", sizeViewerHolder);
      };
    }
  }, []);

  const controlsPrevNext = () => (
    <>
      {currentId !== 0 ? (
        <button className={styles.viewerPrev} type="button" onClick={showPrev}>
          <SvgIcon type="viewer-prev" />
        </button>
      ) : null}
      {currentId + 1 !== props.itemsList.length ? (
        <button className={styles.viewerNext} type="button" onClick={showNext}>
          <SvgIcon type="viewer-next" />
        </button>
      ) : null}
    </>
  );

  return (
    <Box
      className={cx({
        [styles.viewer]: true,
        [`filetype-${currentItem.category}`]: true,
      })}
      pt={{xs: 0, lg: 7}}
      pb={{xs: 0, lg: 3.5}}
      bgcolor={themeVariables.palette.fader}
    >
      <Box className={styles.viewerCloseTrigger} onClick={props.onClose} />
      <Box className={styles.viewerBlock} 
        width={props.currentItem?.category === 'course' ? 600 : 'auto'} maxWidth="100vw"
      >
        <Hidden smUp>
          <Box
            width="100%"
            bgcolor="#fff"
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box className={styles.viewerBlock__infoName} m={2} mr={"20px"}>
              {currentItem?.name ||
                (typeof currentItem.course === "number"
                  ? ""
                  : currentItem?.course?.name)}
            </Box>
            <IconButton
              disableRipple
              disableFocusRipple
              disableTouchRipple
              type="button"
              style={{color: theme.palette.primary.light}}
              onClick={props.onClose}
            >
              <Close color="inherit" fontSize="large" />
            </IconButton>
          </Box>
        </Hidden>
        <Hidden smDown>
          <Box
            position="absolute"
            top={8}
            right={8}
            zIndex={3}
            width={20}
            height={20}
            onClick={props.onClose}
            style={{cursor: "pointer"}}
          >
            <CloseCompact />
          </Box>
        </Hidden>

        <Box className={styles.viewerBlock__wrap}>
          <Box
            clone
            bgcolor={themeVariables.palette.common.black}
            color={themeVariables.palette.common.white}
          >
            <div
              className={styles.viewerBlock__container}
              ref={(ref) => (refContainer = ref)}
              style={currentItem.category === "course" ? null : sizeViewer()}
            >
              {isLoading ? (
                <MUIPreloader
                  cssModifier="svgpreloader-white"
                  position="absolute"
                />
              ) : null}
              {currentItem.category === "image" ? (
                <img
                  key={currentItem.srcUrl}
                  src={currentItem.srcUrl}
                  onLoad={() => setLoading(false)}
                />
              ) : currentItem.category === "course" ? (
                <Box className={styles.courseCover}>
                  {props.courseCover(currentItem.course)}
                </Box>
              ) : currentItem.category === "video" ? (
                !props.currentVideo.status ||
                (props.currentVideo.status === "ok" ? (
                  <Box className={`viewerVideo ${styles.viewerVideo}`}>
                    <iframe 
                      sandbox="allow-scripts allow-downloads allow-popups allow-modals allow-same-origin" 
                      src={`/panel/files/embed/c${currentItem.course}/f${currentItem.id}.html?type=video&iframe=true`}
                      allowFullScreen={true} style={{height: 'fit-content', minHeight:'350px', width: '100%'}} 
                      >
                    </iframe>
                  </Box>
                ) : (
                  props.currentVideo.message
                ))
              ) : (
                currentItem.srcUrl
              )}
              {["image", "course"].includes(currentItem.category) ? (
                <>
                  {controlsPrevNext()}
                  {currentItem.category === "image" && fullscreenAllowed ? (
                    <Box className={styles.viewerFullscreen}>
                      <IconButton onClick={fullscreenToggle}>
                        <SvgIcon
                          type={
                            isFullscreen
                              ? "viewer-smaller"
                              : "viewer-fullscreen"
                          }
                        />
                      </IconButton>
                    </Box>
                  ) : null}
                </>
              ) : null}
            </div>
          </Box>
          <Box
            bgcolor={theme.palette.background.paper}
            className={styles.viewerBlockBottom}
          >
            <Box
              maxWidth={{
                xs: currentItem.category === "course" ? "100%" : 320,
                sm: 658,
              }}
              px={currentItem.category === "course" ? 6 : 2}
              py={2.5}
              className={styles.viewerBlockBottomWrap}
            >
              <Grid container className={styles.viewerBlock__info}>
                <Hidden xsDown>
                  <Grid item xs className={styles.viewerBlock__infoName}>
                    {currentItem?.name ||
                      (typeof currentItem.course === "number"
                        ? ""
                        : currentItem?.course?.name)}
                  </Grid>
                </Hidden>
                {currentItem.category === "course" && props.actionButton ? (
                  <Hidden xsDown>
                    <Grid item>
                      <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        onClick={props.actionButton.onClick}
                        disabled={props.actionButton.disabled}
                      >
                        {props.actionButton.label}
                      </Button>
                    </Grid>
                  </Hidden>
                ) : (
                  <Grid className={styles.viewerBlock__infoDate}>
                    {currentItem.date}
                  </Grid>
                )}
              </Grid>
              {props.children}
            </Box>
          </Box>
          <MUISticky mode="bottom">
            {currentItem.category === "course" && props.actionButton ? (
              <Hidden smUp>
                <Box p={1} bgcolor="white" borderTop={themeVariables.border}>
                  <Button
                    variant="contained"
                    fullWidth
                    className={`MuiButton-shop`}
                    onClick={props.actionButton.onClick}
                    disabled={props.actionButton.disabled}
                  >
                    {props.actionButton.label}
                  </Button>
                </Box>
              </Hidden>
            ) : null}
          </MUISticky>
        </Box>
      </Box>
      <Hidden xsDown>
        <Box className={styles.viewerClose}>
          <IconButton type="button" onClick={props.onClose}>
            <SvgIcon type="modal-close" />
          </IconButton>
        </Box>
      </Hidden>
    </Box>
  );
};
